import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import { FiX } from "react-icons/fi";

import LinkButton from "../LinkButton";
import { SUPPORTED_CHAINS, CHAIN_NAME_MAPPING } from "../../constants";

import logoIcon from "../../img/logo.svg";
import tradeIcon from "../../img/tradeIcon.svg";
import menuIcon from "../../img/menu.svg";

import "../../App.css";
import "./AppHeader.css";

const homeLinks = [
  { name: "Earn", link: "https://app.ktx.finance/earn" },
  { name: "Dashboard", link: "https://app.ktx.finance/dashboard" },
  { name: "Referrals", link: "https://app.ktx.finance/referrals" },
  { name: "Rewards", link: "https://app.ktx.finance/rewards" },
];

function AppHeader() {
  return (
    <div>
      <PcHeader />
      <MobileHeader />
    </div>
  );
}

export function HeaderTabs() {
  return (
    <div className="header-tabs">
      <NavLink to={`/`} exact className="nav-link" activeClassName="active">
        Overview
      </NavLink>

      {SUPPORTED_CHAINS.map((chain) => (
        <NavLink
          key={chain}
          to={`/${chain}`}
          exact
          className="nav-link"
          activeClassName="active"
        >
          {CHAIN_NAME_MAPPING[chain]}
        </NavLink>
      ))}
    </div>
  );
}

function AppHeaderLink({ small, clickCloseIcon }) {
  return (
    <div className="App-header-links">
      {small && (
        <div className="App-header-links-header">
          <NavLink
            exact
            activeClassName="active"
            className="App-header-link-main"
            to="/"
          >
            <img src={logoIcon} alt="KTX Logo" />
          </NavLink>
          <div
            className="App-header-menu-icon-block"
            onClick={() => clickCloseIcon()}
          >
            <FiX className="App-header-menu-icon" />
          </div>
        </div>
      )}

      <div className="App-header-link-container">
        <a
          href="https://docs.ktx.finance/"
          target="_blank"
          className="nav-link"
          rel="noreferrer"
        >
          DOCS
        </a>
      </div>
      {homeLinks.map((item) => (
        <div key={item.link} className="App-header-link-container">
          <a href={item.link} key={item.name} target="_b lank" rel="noreferrer">
            {item.name}
          </a>
        </div>
      ))}

      <div className="tradeWrap">
        <LinkButton
          href="https://app.ktx.finance/trade"
          icon={tradeIcon}
          style={{
            marginLeft: "16px",
            marginRight: "12px",
          }}
        >
          Trade
        </LinkButton>
        <LinkButton
          href="https://app.ktx.finance/buy"
          style={{
            width: "92px",
          }}
        >
          Buy
        </LinkButton>
      </div>
    </div>
  );
}

function PcHeader() {
  return (
    <div className="pc-header">
      <div className="nav">
        <div className="nav-left">
          <a
            href="https://www.ktx.finance/"
            target="_blank"
            className="nav-logo"
            rel="noreferrer"
          >
            <img src={logoIcon} />
          </a>
          <LinkButton
            href="https://app.ktx.finance/trade"
            icon={tradeIcon}
            style={{
              marginLeft: "36px",
              marginRight: "12px",
            }}
          >
            Trade
          </LinkButton>
          <LinkButton
            href="https://app.ktx.finance/buy"
            style={{
              width: "92px",
            }}
          >
            Buy
          </LinkButton>
          <div className="nav-divider"></div>
          {homeLinks.map((item) => (
            <a
              href={item.link}
              key={item.name}
              className="nav-link"
              target="_b lank"
              rel="noreferrer"
            >
              {item.name}
            </a>
          ))}
        </div>
        <div className="nav-right">
          <a
            href="https://docs.ktx.finance/"
            target="_blank"
            className="nav-link"
            rel="noreferrer"
          >
            DOCS
          </a>
        </div>
      </div>

      <HeaderTabs />
    </div>
  );
}

function MobileHeader() {
  const [isDrawerVisible, setIsDrawerVisible] = useState(undefined);

  const slideVariants = {
    hidden: { x: "100%" },
    visible: { x: 0 },
  };

  const fadeVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  return (
    <div className="mobile-header">
      {isDrawerVisible ? (
        <AnimatePresence>
          <motion.div
            className="App-header-backdrop"
            ini
            tial="hidden"
            animate="visible"
            exit="hidden"
            variants={fadeVariants}
            transition={{ duration: 0.2 }}
            onClick={() => setIsDrawerVisible(!isDrawerVisible)}
          />
        </AnimatePresence>
      ) : null}

      <div className="nav">
        <a
          href="https://www.ktx.finance/"
          target="_blank"
          className="nav-logo"
          rel="noreferrer"
        >
          <img src={logoIcon} />
        </a>

        <div onClick={() => setIsDrawerVisible(!isDrawerVisible)}>
          <img src={menuIcon} />
        </div>
      </div>

      <HeaderTabs />

      <AnimatePresence>
        {isDrawerVisible ? (
          <motion.div
            onClick={() => setIsDrawerVisible(false)}
            className="App-header-links-container App-header-drawer"
            initial="hidden"
            animate="visible"
            exit="hidden"
            variants={slideVariants}
            transition={{ duration: 0.2 }}
          >
            <AppHeaderLink
              small
              clickCloseIcon={() => setIsDrawerVisible(false)}
            />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
}

export default AppHeader;
